'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var Groups = function Groups(_ref) {
  var options = _ref.options,
      handleChange = _ref.handleChange,
      selectedCountMap = _ref.selectedCountMap;
  return _react2.default.createElement(
    'ul',
    { className: cx('xsui-group-select__groups') },
    options.map(function (option, index) {
      var selectedCount = selectedCountMap[option.value] || 0;
      var groupItemsCount = option.children.length;
      return _react2.default.createElement(
        'li',
        {
          key: 'group-' + index,
          className: cx('xsui-group-select__groups__option', option.active && 'xsui-group-select__groups__option--active'),
          onClick: handleChange.bind(undefined, option.value) },
        _react2.default.createElement(
          'span',
          { className: 'xsui-group-select__option-label' },
          option.label
        ),
        _react2.default.createElement(
          'span',
          { className: 'xsui-group-select__option-count' },
          groupItemsCount === selectedCount ? groupItemsCount : selectedCount + '/' + groupItemsCount
        )
      );
    })
  );
};

Groups.propTypes = {
  options: _propTypes2.default.array.isRequired,
  handleChange: _propTypes2.default.func.isRequired,
  selectedCountMap: _propTypes2.default.objectOf(_propTypes2.default.number.isRequired).isRequired
};

exports.default = Groups;